import React, { useEffect, useState } from "react";
// import ImageAbout from "../../../assets/images/about.png";
import FotoBgAbout from "../../../assets/images/foto-bg-about.png";
import EffectSplatterWhite from "../../../assets/images/effect-splatter-white.png";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import API_URL from "../../../config/constant";

export default function About() {
    const { t } = useTranslation();
    const [aboutData, setAboutData] = useState(null);
    const locale = useSelector((state) => state.locale.locale);
    useEffect(() => {
        const fetchAboutData = async () => {
            try {
                // eslint-disable-next-line no-undef
                const response = await fetch(`${API_URL}/home?lang=${locale}`);
                if (!response.ok) {
                    throw new Error("Data not found");
                }
                const data = await response.json();
                if (data.about === null) {
                    throw new Error("Data not found");
                }
                setAboutData(data.about);
            } catch (error) {
                setAboutData(t("home.about", { returnObjects: true }));
            }
        };

        fetchAboutData();
    }, [t, locale]);
    return (
        <>
            {/* WILL BE ENABLED SOON */}
            {/* <div className="bg-registerHere min-h-96 bg-no-repeat bg-cover bg-center h-full font-ronzino flex justify-center items-center">
                <div className="text-center bg-[#164481] shadow-md cursor-pointer hover:shadow-2xl duration-300">
                    <p className="text-6xl xl:text-7xl 2xl:text-8xl text-white px-8 py-2">REGISTER HERE</p>
                </div>
            </div> */}
            <div className="bg-primary relative font-wantCoffee min-h-screen flex items-center overflow-hidden">
                <img
                    src={FotoBgAbout}
                    alt="About background"
                    className="absolute bottom-0 left-0 w-auto h-auto max-w-[300px] md:max-w-[400px] lg:max-w-[500px] object-contain z-20 pointer-events-none select-none"
                />
                <img
                    src={EffectSplatterWhite}
                    alt="Decorative splatter effect"
                    className="absolute top-[18rem] -right-[38rem] md:-top-[680px] md:-right-[420px] w-auto h-auto max-w-[1000px] md:max-w-[1920px] object-contain z-10 opacity-50 pointer-events-none select-none"
                />
                <div className="container grid grid-cols-1 md:grid-cols-2 text-white justify-center mx-auto z-[5]">
                    <div className="hidden md:flex w-full text-left flex-col min-h-[777px] justify-center relative bottom-36">
                        <p className="text-6xl md:text-9xl py-2 font-wantCoffee font-normal md:font-bold text-white leading-[0.8]" style={{ letterSpacing: '4px' }}>{aboutData?.title}</p>
                        <p className="text-6xl md:text-9xl py-2 font-superWonder font-normal md:font-bold text-secondary leading-[0.8]" style={{ letterSpacing: '4px' }}>{aboutData?.subTitle}</p>
                        <p className="text-3xl px-3 py-1 font-roboto font-black text-white w-fit relative left-[13rem] md:left-[22rem]" style={{ letterSpacing: '4px' }}>{aboutData?.caption}</p>
                    </div>
                    <div className="flex md:hidden mx-auto">
                        <div className="w-full text-left flex-col pt-0">
                            <p className="text-6xl md:text-9xl py-2 font-wantCoffee font-normal md:font-bold text-white leading-[0.8]" style={{ letterSpacing: '4px' }}>{aboutData?.title}</p>
                            <p className="text-6xl md:text-9xl py-2 font-superWonder font-normal md:font-bold text-secondary leading-[0.8]" style={{ letterSpacing: '4px' }}>{aboutData?.subTitle}</p>
                            <p className="text-2xl px-3 py-0 font-roboto font-black text-white w-fit relative left-[7rem] md:left-[22rem]" style={{ letterSpacing: '4px' }}>{aboutData?.caption}</p>
                        </div>
                    </div>
                    <div className="place-content-center w-full pt-10 pb-24 py-6 uppercase space-y-2 basis-full flex justify-center items-center bg-textBgAboutMobile md:bg-textBgAboutDesktop bg-no-repeat bg-contain bg-center min-h-[50vh] md:min-h-[777px]">
                        <div className="space-y-4 normal-case font-roboto font-medium max-w-[60vw] md:max-w-[400px] text-center md:text-left text-sm md:text-md pt-8">
                            <div
                                className="space-y-4 text-mutedGrey"
                                dangerouslySetInnerHTML={{ __html: aboutData?.content }}
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
